export default class ApiLineConstants {
  static API_LINE = "https://stickershop.line-scdn.net/";
  static API_STICKER = `${ApiLineConstants.API_LINE}stickershop/v1/sticker`;
  static API_EMOJI = `${ApiLineConstants.API_LINE}sticonshop/v1/sticon`;
}
